import { useUser } from '@app/context/UserContext';
import { useNavigation } from '@app/hooks/useNavigation';
import { useUserWithCompany } from '@app/hooks/useUserWithCompany';
import { Button, NotificationModal } from '@components/ui';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';

type Snippet = { text: string; pricingParam: string };

export function RoadblockDSFA() {
  const { t } = useTranslation();
  const { user } = useUser();
  const { whitelabelConfig } = useUserWithCompany();
  const history = useHistory();
  const {
    navigation: {
      onboarding,
      roadBlockDSFA: { modalOpen, open, close },
    },
  } = useNavigation();

  const avatarImage = whitelabelConfig?.avatarB64 && whitelabelConfig.avatarB64 !== 'unset'
    ? whitelabelConfig.avatarB64
    : '/assets/images/dieter_claim.png';

  const handleAlternative = () => {
    close();
  };

  const handleClick = () => {
    history.push('/pricing?option=premium');
  };

  return (
    <NotificationModal open={modalOpen} onClose={() => {}}>
      <div className="flex flex-col p-[30px]">
        <div className="bg-primary-root -mx-[40px] px-9 py-7 -mt-[40px] flex flex-col text-center gap-4">
          <img src={avatarImage} alt="Info" />
          <span className="text-white font-medium text-lg">{t('dashboard.funnel.roadblock.congratulations')}</span>
        </div>

        <div className="pointer-events-auto bg-white my-5">
          <div className="flex flex-col items-center text-center gap-5">
            <span className="">{t('dashboard.funnel.roadblock.dsfa.p1')}</span>
            <span className="mb-5">{t('dashboard.funnel.roadblock.dsfa.p2')}</span>
            <Button onClick={handleClick} data-testid="button-subscribe">
              {t('dashboard.funnel.roadblock.button')}
            </Button>
            <Link to="#" onClick={handleAlternative} data-testid="button-alternative">
              {t('dashboard.funnel.roadblock.alternative')}
            </Link>
          </div>
        </div>
      </div>
    </NotificationModal>
  );
}
